import React, { useState, useEffect } from "react"
import { Form as FormikForm } from "formik"
import cx from "classnames"
import { hubspotEnvID } from "../../../utility/crm/hubspot"
import PropTypes from 'prop-types';

export const FormContext = React.createContext({})

const Form = ({ children, negative = false, big = false, hubspotFormId, className }) => {
  const [ready, setReady] = useState(false)
  useEffect(() => setReady(true), [])

  return <FormContext.Provider value={{
    "negative": false, //negative,
    big,
    hubspot: {
      id: hubspotFormId,
      dialogId: ready ? hubspotEnvID() : undefined
    }
  }}>
    <FormikForm>
      <div className={cx("grid grid-cols-1 gap-3", { "text-negative": false }, className)} >
        {children}
      </div>
    </FormikForm>
  </FormContext.Provider>
}

Form.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
  negative: PropTypes.bool,
  big: PropTypes.bool,
  hubspotFormId: PropTypes.string,
}

export default Form

export const FormDoubleColumn = ({ children }) => {
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
    {children}
  </div>
}